import { Box, Card, CardContent, Grid, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import { MainContainer } from '../../style/GlobalStyles';
import { TableStyled } from './style';

export const skeleton = (
    <>
        {/* <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'fixed', top: '0px', left: '0px', width: '100%', height: '100%', background: 'white' }}>
                <CircularProgress />
            </Box> */}
        <MainContainer>
            {/* Header */}
            <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} marginBottom={'0'}>
                <Skeleton variant="text" sx={{ height: '2rem', width: '20%', minWidth: '15rem' }} />
                <Skeleton
                    variant="rounded"
                    sx={{
                        width: '10%',
                        minWidth: '12rem',
                        height: '2.5rem',

                        display: {
                            xs: 'none',
                            sm: 'block',
                        },
                    }}
                />
            </Box>

            <Grid
                container
                spacing={1}
                sx={{
                    marginTop: '1rem',
                }}
            >
                {Array.from(Array(3).keys()).map((cService, index) => {
                    return (
                        <Grid
                            item
                            key={index}
                            sx={{
                                width: {
                                    xs: '100%',
                                    sm: 'unset',
                                },
                            }}
                        >
                            <Card
                                sx={(theme) => ({
                                    minWidth: 375,
                                    maxWidth: 375,
                                    minHeight: 168,

                                    overflow: 'auto',
                                    boxShadow: 'none',
                                    border: `1px solid ${theme.palette.grey[300]}`,

                                    [theme.breakpoints.down('sm')]: {
                                        minWidth: '100%',
                                        maxWidth: '100%',
                                    },
                                })}
                            >
                                <CardContent
                                    sx={(theme) => ({
                                        display: 'flex',
                                        // padding: theme.typography.generic.medium,

                                        // '&:last-child': {
                                        //     padding: theme.typography.generic.medium,
                                        // },
                                    })}
                                >
                                    <Skeleton
                                        variant="circular"
                                        sx={{
                                            width: '2rem',
                                            height: '2rem',
                                            minWidth: '2rem',
                                            minHeight: '2rem',
                                        }}
                                    />
                                    <Box width={'100%'} marginLeft={'0.5rem'}>
                                        <Skeleton variant="text" sx={{ width: '40%', height: '1.5rem' }} />
                                        {/* <CustomChip label={serviceData.companyName} color="primary" variant="outlined" /> */}
                                        <Skeleton variant="text" sx={{ width: '90%', height: '1rem' }} />
                                        <Skeleton variant="text" sx={{ width: '92%', height: '1rem' }} />
                                        <Skeleton variant="text" sx={{ width: '95%', height: '1rem' }} />

                                        <Box display={'flex'} alignItems={'center'} gap={'0.5rem'} marginTop={'0.5rem'}>
                                            <Skeleton variant="rounded" sx={{ width: '40%', height: '2.5rem' }} />
                                            <Skeleton variant="rounded" sx={{ width: '40%', height: '2.5rem' }} />
                                        </Box>
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>
                    );
                })}
            </Grid>

            <Box marginTop={'1.5rem'} marginBottom={'1.5rem'}>
                <Skeleton
                    variant="rounded"
                    sx={{
                        width: '10%',
                        minWidth: '12rem',
                        height: '2.5rem',

                        display: {
                            xs: 'block',
                            sm: 'none',
                        },
                    }}
                />
            </Box>

            {/* Table UI */}
            <TableContainer
                sx={(theme) => ({
                    color: theme.palette.text.secondary,
                    fontSize: theme.typography.customFontSize.large, // 14px
                    fontWeight: theme.typography.fontWeightRegular,
                    lineHeight: '150%', // Line height as a percentage of font size

                    background: theme.palette.background.paper,
                    borderRadius: theme.typography.borderRadius.xSmall,
                    border: `1px solid ${theme.palette.border.neutralPrimary}`,

                    display: { sm: 'block', xs: 'none' },

                    marginTop: '1.5rem',
                })}
            >
                <TableStyled sx={{ minWidth: 600 }} aria-label="Prime Servces Table">
                    <TableHead>
                        <TableRow>
                            {Array.from(Array(5).keys()).map((cItem) => (
                                <TableCell key={cItem.name} sx={{}}>
                                    {/* <Skeleton variant="text" sx={{ height: '1rem', width: `${(Math.floor(Math.random() * (5 - 3 + 1)) + 3)*10}%`, minWidth: '1rem' }} /> */}
                                    <Skeleton variant="text" sx={{ height: '1rem', width: `30%`, minWidth: '1rem' }} />
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {Array.from(Array(5).keys()).map((id) => (
                            <TableRow key={id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                {Array.from(Array(5).keys()).map((id) => (
                                    <TableCell key={id} align="left">
                                        <Skeleton variant="text" sx={{ height: '1.5rem', width: `40%`, minWidth: '1.5rem' }} />
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </TableStyled>
            </TableContainer>

            {/* List UI for mobile view */}

            <Box
                component={'ul'}
                sx={{
                    listStyleType: 'none',
                    paddingBottom: '1.5rem',

                    display: { sm: 'none', xs: 'block' },
                }}
            >
                {Array.from(Array(5).keys()).map((id) => (
                    <Box
                        key={id}
                        component={'li'}
                        sx={(theme) => ({
                            borderRadius: theme.typography.borderRadius.xxSmall,
                            border: `1px solid ${theme.palette.grey[300]}`,
                            background: theme.palette.background.paper,

                            padding: `${theme.typography.generic.medium} ${theme.typography.generic.large}`,
                            width: '100%',

                            marginBottom: theme.typography.generic.xLarge,

                            display: 'flex',
                            flexDirection: 'column',

                            gap: '0.725rem',
                        })}
                    >
                        {Array.from(Array(5).keys()).map((id) => (
                            <Box key={id} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Skeleton variant="text" sx={{ height: '2rem', width: '35%', minWidth: '1.5rem', maxWidth: '45%' }} />

                                <Skeleton variant="text" sx={{ height: '2rem', width: '35%', minWidth: '1.5rem', maxWidth: '45%' }} />
                            </Box>
                        ))}
                    </Box>
                ))}
            </Box>
        </MainContainer>
    </>
);
